import { useState, useEffect, useRef } from "react";
import {
  Typography,
  Box,
  Button,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  DialogContentText,
} from "@mui/material";
import { rsActiveMenu, rsProgress, rsScrollComment } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseReminder } from "./UseReminder";
import { toMoney } from "../../util/Utils";
import ClearIcon from "@mui/icons-material/Clear";
import ProgressCom from "../../components/ProgressCom";
import CustomPagination from "../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";

export default function CustomersList(props) {
  const { GetCustomersList, SendReminderSMS } = UseReminder();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [open, setOpen] = useState(false);
  const [customerRes, setCustomerRes] = useState();
  const [pageState, setPageState] = useState({
    page: 1,
  });

  useEffect(() => {
    if (props.openCustomers && props.openCustomers.productID) {
      setProgress(true);
      GetCustomersList(props.openCustomers.productID, (callback) => {
        setProgress(false);
        setCustomerRes(callback);
      });
    }
  }, [props.openCustomers]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "mobile",
      width: 150,
      align: "center",
      headerName: "شماره",
      headerAlign: "center",
      sortable: false,
    },
  ];

  return (
    <Dialog
      PaperProps={{
        elevation: 1,
      }}
      maxWidth="sm"
      fullWidth
      open={props.openCustomers.show}
      onClose={() =>
        props.setOpenCustomers({ ...props.openCustomers, show: false })
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="secondary" id="alert-dialog-title">
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography color="secondary" variant="subtitle2">
            لیست مشتریان
          </Typography>
          <IconButton
            onClick={() => {
              props.setOpenCustomers({ ...props.openCustomers, show: false });
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از ارسال SMS اطمینان دارید ؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() =>
                SendReminderSMS(props.openCustomers.productID, (callBack) => {
                  props.callBack();
                  setOpen(false);
                })
              }
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setOpen(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        <Box sx={{ height: "30rem" }}>
          {customerRes ? (
            <DataGrid
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              rows={customerRes ? customerRes : []}
              page={pageState.page - 1}
              pageSize={20}
              Pagination
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...pageState, page: newPage + 1 }));
              }}
              rowCount={
                customerRes && customerRes.length ? customerRes.length : 1
              }
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  nofab: true,
                  rowCount: customerRes.length ? customerRes.length : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: "id",
                      sort: "asc",
                    },
                  ],
                },
              }}
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
        {props.openCustomers.stockState == "available" && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Button variant="contained" onClick={() => setOpen(true)}>
              ارسال SMS
            </Button>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
